import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PulseParticipationOverallComponent} from './pulse-participation-overall.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PulseParticipationOverallComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PulseParticipationOverallComponent]
})
export class PulseParticipationOverallModule {
}
